// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"28497993","453":"b5e0f593","455":"25865dd1","952":"53f627f1"}[chunkId] + ".chunk.js";
};